export const meta: BlockMeta = {
  title: "Related Journals",
  tags: ["#page"],
}

import { JournalTile } from "@components/content/JournalTile"
import { defineBlock, EditableText } from "eddev/blocks"

export default defineBlock("content/related-journals", (props) => {
  const journals = props.journal?.journalHeader?.category?.contentNodes?.nodes.filter(Boolean) || []

  if (journals.length < 3) {
    journals.push(...(props.allJournals?.nodes ?? []))
  }

  if (journals.length === 0) {
    return null
  }

  return (
    <div className="content-sized block-spacing relative flex flex-col gap-6">
      <EditableText
        as="h3"
        store="title"
        className="type-desktop-headings-heading-s pb-7"
        placeholder="Latest journal entries"
        defaultValue="Latest journal entries"
      />
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {journals
          ?.slice(0, 3)
          .filter((journal) => !!journal && "uri" in journal)
          .map((journal, index) => (
            <JournalTile key={journal.id} journal={journal} />
          ))}
      </div>
    </div>
  )
})
